import { Helmet } from "react-helmet-async";
import { useState } from "react";
import { useNavigate, Navigate, useLocation } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../contexts/AuthContext";
import { formatApiErrorDetail } from "../lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.startsWith("/admin") ? location.state.from : "/admin";
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user && user.role === "admin") return <Navigate to={from} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bine ai revenit.");
      navigate(from, { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Autentificare eșuată");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <Helmet><meta name="robots" content="noindex, nofollow" /><title>Admin | Apuseni Active</title></Helmet>
    <div className="min-h-screen bg-bone flex items-center justify-center px-6 py-32" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-xs uppercase tracking-wider-3 text-moss mb-6">Apuseni Active · Admin</div>
        <h1 className="font-display text-5xl text-forest leading-[1.05]">Bun revenit.</h1>
        <p className="mt-4 text-sm text-muted-foreground">Conectează-te pentru a gestiona cererile de rezervare.</p>

        <form onSubmit={submit} className="mt-12 space-y-6" data-testid="admin-login-form">
          <label className="block">
            <span className="text-[10px] uppercase tracking-wider-3 text-moss block mb-2">Email</span>
            <input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              className="w-full bg-white border border-border px-4 py-3.5 text-sm outline-none focus:border-forest transition-colors"
            />
          </label>
          <label className="block">
            <span className="text-[10px] uppercase tracking-wider-3 text-moss block mb-2">Parolă</span>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              className="w-full bg-white border border-border px-4 py-3.5 text-sm outline-none focus:border-forest transition-colors"
            />
          </label>
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="btn-lift w-full bg-forest text-bone px-6 py-4 text-xs uppercase tracking-wider-3 disabled:opacity-60 hover:bg-forest-deep"
          >
            {loading ? "Se autentifică…" : "Autentificare"}
          </button>
        </form>
      </div>
    </div>
    </>
  );
}
